import React from "react";
import { useState } from "react";
import { ButtonBurger } from "../ButtonBurger";
import { useNavigate } from "react-router-dom";
import CompanyDropdown from "../../others/CompanyDropdown/CompanyDropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { setProfileUser } from "../../../store/user/actions";
import { dropDownItems } from "./dropdownItems";
import { Link } from "react-router-dom";
import { Company, DropDownCompany } from "./Navbar.type";

const rolesDictionary: { [key: string]: string } = {
  'SUPER_ADMIN_LAVORIS': 'Super Administrador Lavoris',
  'ADMIN_LAVORIS': 'Administrador Lavoris',
  'COMPANY_ADMIN': 'Administrador de la Empresa',
  'COMPANY_ACCOUNTANT': 'Contador de la Empresa',
  'COMPANY_CANDIDATE': 'Candidato de Empresa',
  'COMPANY_EMPLOYEE': 'Empleado de Empresa',
  'PARTICULAR_CLIENT': 'Cliente Particular',
  'COMPANY_CONTACT': 'Empleado de Empresa',
  'ABSENTEE_DOCTOR': 'Doctor de ausentismo',
  'OCCUPATIONAL_DOCTOR': 'Doctor de medicina laboral',
  'PROFESSIONAL': 'Profesional',
  'RRHH': 'RRHH',
  'RRHH_APPOINTMENTS': 'RRHH turnos y resultado de turnos',
  'CANDIDATE_APPOINTMENTS': 'RRHH turnos Postulantes',
  'RRHH_APPOINTMENTS_AND_ABSENTEE': 'RRHH turnos S/Res',
  'RRHH_RESULT': 'RRHH Resultados',
  'RRHH_ABSENTEE': 'RRHH ausentismos y resultado de ausentismos',
  'ADM_ABSENTEE': 'ADM Ausentismo',
  'ACCOUNTANT': 'Contador',
  'ASESOR': 'Asesor',
}

interface NavBarProps {
  onMobileMenuToggle?: () => void;
}

function NavBar({ onMobileMenuToggle }: NavBarProps) {
  let dispatch = useDispatch();
  const reduxStore = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();
  const [companies, setCompanies] = useState(dropDownItems);
  const [profile, setProfile] = useState(reduxStore);

  // HANDLE ROLE CHANGES
  const chosenRole: string = reduxStore?.currentRole;
  const DROPDOWN: any = {
    COMPANY_ADMIN: (
      <CompanyDropdown
        menuItems={companies}
        handleChosenCompany={(item: DropDownCompany) =>
          handleChosenCompany(item)
        }
      />
    ),
    ASESOR: (
      <div className="asesor-no-profile">
        {/* No muestra perfil ni dropdown para ASESOR */}
      </div>
    ),
    PARTICULAR_CLIENT: (
      <Link to="/Cuenta">
        <img
          src="/images/Profile.svg"
          className="profile-image"
          alt="Profile"
        />
      </Link>
    ),
    RRHH: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_APPOINTMENTS: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    CANDIDATE_APPOINTMENTS: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_APPOINTMENTS_AND_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_RESULT: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    ADM_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    ACCOUNTANT: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
  };

  //Helper Functions
  const handleChosenCompany = (item: DropDownCompany) => {
    let chosenProfile = profile?.companies?.find(
      (company: Company) => company.fantasyName === item.title,
    );
    //Check if dropdown click was on a Company. If so, update Redux
    if (chosenProfile) {
      let updatedProfile = profile;
      updatedProfile.currentCompany = chosenProfile;
      const setProfileRedux = async () => {
        try {
          let response = dispatch(setProfileUser(updatedProfile));
          let currentCompany: string | undefined =
            response.payload.currentCompany?.fantasyName;
          if (currentCompany === updatedProfile.currentCompany.fantasyName) {
            setTimeout(() => window.location.reload(), 500);
          }
        } catch (e) {
          console.log(e);
        }
      };
      setProfileRedux();
    } else {
      item.title === "Ver mi cuenta" && navigate(`/Cuenta/Datos-Empresa`);
    }
  };

  const getCodClient = () => {
    if (!profile) return "---";
    
    if (profile.currentCompany?.managerId) {
      return profile.currentCompany.managerId;
    }
    
    if (profile.companies && profile.companies.length > 0) {
      const firstCompany = profile.companies[0];
      if (firstCompany && firstCompany.managerId) {
        return firstCompany.managerId;
      }
    }
    
    return "---";
  }

  // Determinar si mostrar el botón hamburguesa (roles que tienen sidebar)
  const SIDEBAR_ROLES = [
    "COMPANY_ADMIN",
    "PARTICULAR_CLIENT",
    "RRHH",
    "RRHH_APPOINTMENTS",
    "CANDIDATE_APPOINTMENTS",
    "RRHH_APPOINTMENTS_AND_ABSENTEE",
    "RRHH_RESULT",
    "RRHH_ABSENTEE",
    "ADM_ABSENTEE",
    "ACCOUNTANT",
    "ASESOR",
  ];

  const showMobileMenuButton = SIDEBAR_ROLES.includes(chosenRole);

  return (
    <div className="navbar-atendoo">
      <div className="navbar-left">
        {/* Botón hamburguesa para mobile */}
        {showMobileMenuButton && onMobileMenuToggle && (
          <button
            className="mobile-menu-btn"
            onClick={onMobileMenuToggle}
            aria-label="Abrir menú"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        )}

        {/* ButtonBurger original para desktop */}
        <div className="desktop-burger">
          <ButtonBurger />
        </div>
      </div>

      <div className="navbar-title">
        <div className="user-info d-none d-sm-flex flex-sm-column">
          <span className="welcome-text">
            Hola {chosenRole === "ASESOR" ? profile?.name : (profile?.companies && profile?.companies[0]?.socialReason || profile?.name || profile?.email)}!
          </span>
          <div className="role-info">
            {rolesDictionary[chosenRole] && (
              <span className="role-text">
                {rolesDictionary[chosenRole]}
              </span>
            )}
            {chosenRole !== "PARTICULAR_CLIENT" && (
              <>
                <span className="divider"> | </span>
                <span className="client-code">
                  Cliente: #{getCodClient()}
                </span>
              </>
            )}
          </div>
        </div>
        <div className="avatar-atendoo d-none d-sm-flex">
          {DROPDOWN[chosenRole] ? DROPDOWN[chosenRole] : <></>}
        </div>
        <div className="d-flex d-sm-none">
          <a href="/" className="logo-link">
            <img
              src="/images/Logo_Lavorix.png"
              alt="Lavorix"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default React.memo(NavBar);